var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconToilet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.892,
    x2: 417.392,
    xlinkHref: "#lg1",
    y1: 133.91,
    y2: 133.91
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.608,
    x2: 135.108,
    xlinkHref: "#lg1",
    y1: 133.91,
    y2: 133.91
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.059,
    x2: 277.288,
    xlinkHref: "#lg2",
    y1: 85.25,
    y2: 346.249
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.586,
    x2: 174.586,
    xlinkHref: "#lg2",
    y1: 462.573,
    y2: 80.573
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.925,
    x2: -41.174,
    xlinkHref: "#lg3",
    y1: 223.531,
    y2: -58.352
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.173,
    x2: 100.996,
    xlinkHref: "#lg3",
    y1: 219.469,
    y2: -48.711
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.114,
    x2: -17.369,
    xlinkHref: "#lg3",
    y1: 336.734,
    y2: 271.901
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.16,
    x2: 121.744,
    xlinkHref: "#lg3",
    y1: 336.749,
    y2: 271.937
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.42,
    x2: 110.98,
    xlinkHref: "#lg4",
    y1: 126.943,
    y2: 186.503
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.25,
    x2: 167.629,
    xlinkHref: "#lg4",
    y1: 257.976,
    y2: 404.355
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#e9d6f7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#c5b5de",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#aa9bcb",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688bd",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8a7db5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.108,
    x2: 23.108,
    xlinkHref: "#lg5",
    y1: 250.338,
    y2: 373.801
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.138,
    x2: -44.989,
    xlinkHref: "#lg5",
    y1: 333.539,
    y2: 427.732
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.131,
    x2: 121.131,
    xlinkHref: "#lg5",
    y1: 250.338,
    y2: 373.801
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.42,
    x2: 249.98,
    xlinkHref: "#lg4",
    y1: 126.943,
    y2: 186.503
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.25,
    x2: 306.629,
    xlinkHref: "#lg4",
    y1: 257.975,
    y2: 404.355
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.108,
    x2: 162.108,
    xlinkHref: "#lg5",
    y1: 250.338,
    y2: 373.801
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.131,
    x2: 260.131,
    xlinkHref: "#lg5",
    y1: 250.338,
    y2: 373.801
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.118,
    x2: 211.118,
    xlinkHref: "#lg5",
    y1: 366.15,
    y2: 268.6
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.138,
    x2: 94.012,
    xlinkHref: "#lg5",
    y1: 333.539,
    y2: 427.732
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m417.392 191.891h-42.5v-94.712c0-11.736 9.514-21.25 21.25-21.25 11.736 0 21.25 9.514 21.25 21.25z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.108 191.891h-42.5v-94.712c0-11.736 9.514-21.25 21.25-21.25 11.736 0 21.25 9.514 21.25 21.25z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m483.065 401.85h-456.13c-14.876 0-26.935-12.059-26.935-26.934v-214.071c0-14.876 12.059-26.935 26.935-26.935h456.131c14.876 0 26.935 12.059 26.935 26.935v214.071c-.001 14.875-12.06 26.934-26.936 26.934z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.261 375.869h-402.522c-12.515 0-22.661-10.146-22.661-22.661v-170.656c0-12.515 10.146-22.661 22.661-22.661h402.522c12.515 0 22.661 10.146 22.661 22.661v170.657c0 12.515-10.146 22.66-22.661 22.66z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff6359"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m455.429 310.82h-171.905c-4.149 0-7.512-3.363-7.512-7.512v-13.016c0-4.149 3.363-7.512 7.512-7.512h171.905c4.149 0 7.512 3.363 7.512 7.512v13.016c0 4.149-3.363 7.512-7.512 7.512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.887 358.52h-91.363c-4.149 0-7.512-3.363-7.512-7.512v-13.016c0-4.149 3.363-7.512 7.512-7.512h91.363c4.149 0 7.512 3.363 7.512 7.512v13.016c0 4.149-3.363 7.512-7.512 7.512z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m44.077 181.455 220.395 220.395h117.314l-267.94-267.94h-81.457c-1.421 4.321-2.201 8.934-2.201 13.731 0 13.601 4.183 25.756 13.889 33.814z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.077 181.455 220.395 220.395h76.822c14.943 0 22.426-18.067 11.86-28.633l-239.307-239.307h-81.458c-1.421 4.321-2.201 8.934-2.201 13.731 0 13.601 4.183 25.756 13.889 33.814z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.617 401.85-191.794-191.793c-6.064-7.256-15.179-10.874-25.375-10.874h-56.662c-18.258 0-32.059 13.801-32.059 32.059v41.056c0 7.904 2.709 14.938 8.476 19.471 1.225 1.558 15.299 15.603 16.281 16.506v93.575z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.617 401.85-191.794-191.793c-6.064-7.256-15.179-10.874-25.375-10.874h-56.663c-17.706 0-32.059 14.353-32.059 32.059v41.057c0 7.904 2.709 14.938 8.476 19.471.928 1.18 9.23 9.527 13.628 13.897l-13.465 21.506c-2.042 3.262-1.555 7.503 1.174 10.217l14.944 14.86v49.6z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 72.118,
    cy: 147.641,
    fill: "url(#SVGID_9_)",
    r: 43.93
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m100.449 198.183h-56.663c-18.258 0-33.059 14.801-33.059 33.059v41.056c0 13.673 11.084 24.757 24.757 24.757v121.352c0 8.65 7.012 15.663 15.663 15.663h41.94c8.65 0 15.663-7.012 15.663-15.663v-121.351c13.673 0 24.757-11.084 24.757-24.757v-41.056c.001-18.259-14.8-33.06-33.058-33.06z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.489 199.227v97.828c-13.677 0-24.761-11.084-24.761-24.753v-41.058c-.001-15.4 10.517-28.334 24.761-32.017z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.449 198.183h-28.331v235.888h20.97c8.65 0 15.663-7.012 15.663-15.663v-121.352c13.673 0 24.757-11.084 24.757-24.757v-41.056c0-18.259-14.801-33.06-33.059-33.06z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.511 231.245v41.058c0 6.834-2.771 13.027-7.248 17.504-4.486 4.477-10.67 7.248-17.513 7.248v-97.828c14.244 3.692 24.761 16.626 24.761 32.018z",
    fill: "url(#SVGID_13_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 211.118,
    cy: 147.641,
    fill: "url(#SVGID_14_)",
    r: 43.93
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m247.751 297.056c13.673 0 24.757-11.084 24.757-24.757v-41.056c0-18.258-14.801-33.059-33.059-33.059h-56.663c-18.258 0-33.059 14.801-33.059 33.059v41.057c0 13.673 11.084 24.757 24.757 24.757v.005l-16.46 27.863c-3.665 6.204.807 14.039 8.012 14.039h8.448v79.444c0 8.65 7.012 15.663 15.663 15.663h41.94c8.65 0 15.663-7.012 15.663-15.663v-79.444h8.451c7.205 0 11.677-7.836 8.012-14.039z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.489 199.227v97.828c-13.677 0-24.761-11.084-24.761-24.753v-41.058c-.001-15.4 10.517-28.334 24.761-32.017z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.511 231.245v41.058c0 6.834-2.771 13.027-7.248 17.504-4.486 4.477-10.67 7.248-17.513 7.248v-97.828c14.244 3.692 24.761 16.626 24.761 32.018z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m174.485 418.408c0 8.65 7.012 15.663 15.663 15.663h41.94c8.65 0 15.663-7.013 15.663-15.663v-79.444h-73.266z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.449 198.183h-28.331v235.888h20.97c8.65 0 15.663-7.012 15.663-15.663v-121.352c13.673 0 24.757-11.084 24.757-24.757v-41.056c0-18.259-14.801-33.06-33.059-33.06z",
    fill: "url(#SVGID_19_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToilet);
export default __webpack_public_path__ + "static/media/icon-toilet.4469cdfb9d987568f35dc8160ca45838.svg";
export { ForwardRef as ReactComponent };